import React from "react";
import { useLang } from "@/i18n";
import { OrnateHeartDivider } from "./FloralOrnaments";

export default function Footer({ wedding }) {
    const { t, lang } = useLang();
    return (
        <footer className="py-10 px-6 text-center" data-testid="footer">
            <div className="max-w-md mx-auto">
                <div className="flex justify-center"><OrnateHeartDivider /></div>
                <p className="wd-script text-2xl text-[var(--wd-primary)] mt-6" translate="no">
                    {lang === "ar"
                        ? `${wedding.groom_ar} و${wedding.bride_ar}`
                        : `${wedding.groom_en} & ${wedding.bride_en}`}
                </p>
                <p className="text-xs text-[var(--wd-text-muted)] mt-4">
                    {t("footer")}
                </p>
            </div>
        </footer>
    );
}
